import { create } from "zustand";

const useAutoschedulerDebugStore = create((set, get) => ({
  // Modal state
  isDebugModalOpen: false,

  // Debug stats from API response
  debugStats: null,

  // Timestamp of last update
  lastUpdated: null,

  // Actions
  openDebugModal: () => set({ isDebugModalOpen: true }),
  closeDebugModal: () => set({ isDebugModalOpen: false }),

  // Hydrate store with debug stats from API response
  setDebugStats: (stats) =>
    set({
      debugStats: stats,
      lastUpdated: new Date().toISOString(),
    }),

  // Clear debug stats
  clearDebugStats: () =>
    set({
      debugStats: null,
      lastUpdated: null,
    }),

  // Check if debug stats are available
  hasDebugStats: () => get().debugStats !== null,
}));

export default useAutoschedulerDebugStore;
